module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('span', {
    staticClass: "loading text-muted"
  }, [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('supplier-r-f-q-table', {
    staticClass: "pr-1",
    attrs: {
      "name": "standard",
      "title": "Standard",
      "data": _vm.data.standard
    }
  }), _vm._v(" "), _c('supplier-r-f-q-table', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "overnight",
      "title": "Overnight",
      "data": _vm.data.overnight
    }
  }), _vm._v(" "), _c('supplier-r-f-q-table', {
    staticClass: "pl-1",
    attrs: {
      "name": "expedited",
      "title": "Expedited",
      "icon": "expeditedOne",
      "data": _vm.data.expedited
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-504ce6a9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/SupplierRFQWidget.vue
// module id = 710
// module chunks = 0